document.addEventListener("DOMContentLoaded", () => {
	const maxAttempts = 30;
	let attempts = 0;

	const interval = setInterval(() => {
		const formEmbed = document.getElementById('app-embed');
		if (formEmbed?.shadowRoot) {
			const section = formEmbed.shadowRoot.querySelector('section[data-testid="form-container"]');
			if (section) {
				const style = document.createElement('style');
				style.textContent = `
					div[data-testid="app-router"] {
						padding: 0 var(--spacing-3);
						width: unset;

						@media (min-width: 768px) {
						padding: 0 var(--spacing-3);
						width: 100%;}
						}

					input, button, textarea {
						box-shadow: none !important;
						border: 1px solid #dedede !important;
						border-radius: 0 !important;
						background-color: #fafafa !important;
					}

					button[type="submit"] {
						background-color: #000 !important;
						text-transform: uppercase !important;
						font-size: var(--font-size-text) !important;
						width: fit-content !important;

						&:hover {
							background-color: #333 !important;
							color: #fff !important;
						}
					}

				`;
				formEmbed.shadowRoot.appendChild(style);
				clearInterval(interval);
			}
		}

		attempts++;
		if (attempts >= maxAttempts) {
			clearInterval(interval);
			console.warn('Form embed not found after 30 attempts.');
		}
	}, 500);
});